var _defs, _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAdminPortalPhone(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "a",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 300 300",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .b {\n        stroke-width: 2px;\n      }\n\n      .b, .c {\n        fill: none;\n        stroke: #fff;\n        stroke-linecap: round;\n        stroke-linejoin: round;\n      }\n\n      .d {\n        fill: #fff;\n      }\n\n      .e {\n        fill: #6f3d90;\n      }\n    "))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "d",
    x: 112.67,
    y: 152.59,
    width: 75.02,
    height: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "e",
    cx: 150,
    cy: 150,
    r: 120
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 109.55,
    y: 80,
    width: 80.9,
    height: 140,
    rx: 10.37,
    ry: 10.37
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 109.55,
    y: 95.52,
    width: 80.9,
    height: 108.97
  }), /*#__PURE__*/React.createElement("line", {
    className: "b",
    x1: 144.54,
    y1: 88.11,
    x2: 155.29,
    y2: 88.11
  }), /*#__PURE__*/React.createElement("rect", {
    className: "b",
    x: 146.71,
    y: 209.17,
    width: 6.4,
    height: 6.4
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M172.59,110.1h-51.76c-1.07,0-1.94.87-1.94,1.94v19.67c0,1.07.87,1.94,1.94,1.94h1.68v8.38l8.38-8.38h41.7c1.07,0,1.94-.87,1.94-1.94v-19.67c0-1.07-.87-1.94-1.94-1.94Z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "c",
    d: "M128.16,158.35h51.76c1.07,0,1.94.87,1.94,1.94v19.67c0,1.07-.87,1.94-1.94,1.94h-1.68v8.38l-8.38-8.38h-41.7c-1.07,0-1.94-.87-1.94-1.94v-19.67c0-1.07.87-1.94,1.94-1.94Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminPortalPhone);
export default __webpack_public_path__ + "static/media/admin_portal_phone.5d99798ac2d50657048fa4d1aa78ad69.svg";
export { ForwardRef as ReactComponent };